import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';

export const notGuestUserGuard : CanActivateFn = (route, state) => {
  const calService = inject(CalAngularService);
  // we need to check for the user type and make sure they are not a guest (guests are not allowed to access the app)
  return calService.isUserSignedIn() && calService.cvxClaimsPrincipal.userType.toLocaleLowerCase() !== 'guest'
}
